import { useDispatch } from "react-redux";

import {
  getListData,
  deleteConditionData,
  cloneConditionData,
  getConstantsData,
  createConditionData,
  getViewConditionData,
  editConditionData,
  clearListState,
  clearDeleteConditionState,
  clearCloneConditionState,
  clearCreateConditionState,
  clearViewConditionState,
  clearConstantsState,
  clearEditConditionState,
  payloadConditionsList,
  payloadCloneConditions,
  getOffersIdData,
  getExternalCurrencyData,
  clearExternalCurrencyConditionState,
  archiveDealData,
  clearOffersIdState,
  clearArchiveConditionState,
  renameDealData,
  getArchivedListData,
  clearArchivedListState,
  getBrandsListData,
  clearBrandsListState,
  getFilterCreatorData,
  getBrandsForDealData,
  clearBrandsForDealState,
  getDealTrackersData,
  clearDealTrackersState,
} from "./index";


export const useConditions = () => {
  const dispatch = useDispatch();

  const getList = (data: payloadConditionsList) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());

  const getArchivedList = (data: payloadConditionsList) => dispatch(getArchivedListData(data));
  const clearArchivedList = () => dispatch(clearArchivedListState());

  const deleteCondition = (data: any) => dispatch(deleteConditionData(data));
  const clearDeleteCondition = () => dispatch(clearDeleteConditionState());

  const cloneCondition = (data: payloadCloneConditions) => dispatch(cloneConditionData(data));
  const clearCloneCondition = () => dispatch(clearCloneConditionState());

  const getConstants = () => dispatch(getConstantsData());
  const clearConstants = () => dispatch(clearConstantsState());

  const createCondition = (data: any) => dispatch(createConditionData(data));
  const clearCreateCondition = () => dispatch(clearCreateConditionState());

  const getViewCondition = (id: string) => dispatch(getViewConditionData(id));
  const clearViewCondition = () => dispatch(clearViewConditionState());

  const editCondition = (data: any) => dispatch(editConditionData(data));
  const clearEditCondition = () => dispatch(clearEditConditionState());

  const getOffersId = (data: any) => dispatch(getOffersIdData(data));
  const getExternalCurrency = (data: any) => dispatch(getExternalCurrencyData(data));
  const clearExternalCurrencyCondition = () => dispatch(clearExternalCurrencyConditionState());
  const clearOffersId = () => dispatch(clearOffersIdState());
  const archiveDeal = (data:any) => dispatch(archiveDealData(data));

  const clearArchiveCondition = () => dispatch(clearArchiveConditionState());
  const renameDeal = (data:any) => dispatch(renameDealData(data));

  const getBrandsList = (data: any) => dispatch(getBrandsListData(data));
  const clearBrandsList = () => dispatch(clearBrandsListState());
  const getFilterCreator = (data: any) => dispatch(getFilterCreatorData(data));

  const getBrandsForDeal = (data: any) => dispatch(getBrandsForDealData(data));
  const clearBrandsForDeal = () => dispatch(clearBrandsForDealState());

  const getDealTrackers = (data: any) => dispatch(getDealTrackersData(data));
  const clearDealTrackers = () => dispatch(clearDealTrackersState());

  return {
    getList,
    clearList,
    deleteCondition,
    clearDeleteCondition,
    cloneCondition,
    clearCloneCondition,
    getConstants,
    clearConstants,
    createCondition,
    clearCreateCondition,
    getViewCondition,
    clearViewCondition,
    editCondition,
    clearEditCondition,
    getOffersId,
    getExternalCurrency,
    clearExternalCurrencyCondition,
    archiveDeal,
    clearOffersId,
    clearArchiveCondition,
    renameDeal,
    getArchivedList,
    clearArchivedList,
    getBrandsList,
    clearBrandsList,
    getFilterCreator,
    getBrandsForDeal,
    clearBrandsForDeal,
    getDealTrackers,
    clearDealTrackers,
  }
}
